import { reportktv, reportVaddA3PayReport } from '../../utils/log/log';
import { getFromPath, getCurrentRoute } from '../../utils/log/track/util';

// 支付成功钩子
export function handlePaySuccess(data) {
    const from_path = getFromPath()
    const curRoute = getCurrentRoute()
    reportktv({
      tp: '支付成功',
      str2: data.is_vip,
      str3: data.is_expired_vip,
      str4: data.order_id,
    })
    reportVaddA3PayReport({
        event_name: 1,
        event_data: {
            event_time: Date.now(),
            page_name: curRoute.page_name,
            page_path: curRoute.page_path,
            from_path,
        },
    });
}

// 支付失败钩子
export function handlePayFailed() {
    const from_path = getFromPath()
    const curRoute = getCurrentRoute()
    reportVaddA3PayReport({
        event_name: 2,
        event_data: {
            event_time: Date.now(),
            page_name: curRoute.page_name,
            page_path: curRoute.page_path,
            from_path,
        },
    });
}

// 支付取消钩子
export function handlePayCancel() {
    const from_path = getFromPath()
    const curRoute = getCurrentRoute()
    reportVaddA3PayReport({
        event_name: 3,
        event_data: {
            event_time: Date.now(),
            page_name: curRoute.page_name,
            page_path: curRoute.page_path,
            from_path,
        },
    });
}
